import {Button, Modal, Spinner} from 'react-bootstrap'
import OtpInput from 'react-otp-input'
import Countdown from 'react-countdown'
import {useTranslation} from 'react-i18next'
import {useEffect, useMemo, useState} from 'react'

const DEFAULT_TIMER = 40000

interface Props {
  show: boolean
  isLoading: boolean
  onHide: () => void
  onGenerateOTP: () => void
  onSubmitOTP: (value: string) => void
}

export const ModalInputAndGenerateOTP = (props: Props) => {
  const {t} = useTranslation()
  const [otp, setOtp] = useState('')
  const [count, setCount] = useState(Date.now() + DEFAULT_TIMER)
  const [disableOTPInput, setDisableOTPInput] = useState(false)

  const handleCloseModal = () => {
    setOtp('')
    setCount(0)
    props.onHide()
  }

  const handleGenerateOTP = () => {
    setCount(Date.now() + DEFAULT_TIMER)
    setDisableOTPInput(false)
    props.onGenerateOTP()
  }

  useEffect(() => {
    return () => {
      handleCloseModal()
    }
  }, [])

  return (
    <Modal show={props.show} onHide={handleCloseModal} centered backdrop='static'>
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div className='justify-content-center'>
          <h1 className='text-center'>{t('Masukkan Kode OTP')}</h1>
          <div className='text-center'>
            {t('Masukkan 6 kode OTP yang telah dikirimkan ke nomor handphone anda')}
          </div>
        </div>

        <div className='d-flex justify-content-center flex-column align-items-center'>
          <OtpInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            renderSeparator={<span>&nbsp;&nbsp;</span>}
            renderInput={(renderInputProps) => (
              <input disabled={disableOTPInput} {...renderInputProps} />
            )}
            containerStyle={{
              margin: '0 auto',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: '1rem',
              marginBottom: '1rem',
            }}
            inputStyle={{
              width: 64,
              height: 64,
              fontSize: 30,
              fontWeight: 'bold',
              borderRadius: 8,
              border: '1.5px solid #9c9c9c',
              color: '#274070',
            }}
          />

          {count != 0 && (
            <Countdown
              date={count}
              zeroPadTime={2}
              renderer={({hours, minutes, seconds, completed, days}) => {
                if (completed) {
                  setOtp('')
                  setCount(0)
                  setDisableOTPInput(true)
                  return null
                }

                return (
                  <span style={{fontSize: 14, color: '#274070'}}>
                    Kirim ulang OTP dalam 0{hours}:0{minutes}:
                    {seconds < 9 ? `0${seconds}` : seconds}
                  </span>
                )
              }}
            />
          )}

          {(count === 0 || props.isLoading) && (
            <Button disabled={props.isLoading} variant='primary' onClick={handleGenerateOTP}>
              {t('Generate OTP')}
            </Button>
          )}
        </div>
      </Modal.Body>

      {!disableOTPInput && (
        <Modal.Footer>
          <Button variant='secondary' onClick={handleCloseModal}>
            {t('cancel')}
          </Button>

          <Button
            variant='success'
            disabled={props.isLoading || otp.length !== 6}
            onClick={() => {
              setCount(0)
              props.onSubmitOTP(otp)
            }}
          >
            {props.isLoading ? <Spinner animation='border' size='sm' /> : t('Kirim')}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  )
}
